module.exports = __webpack_public_path__ + "static/website_creation-cc03c9e14e2ec43e3b5ecbfc66214cf1.jpg";